import { instance } from "libs/api";

import { ApiRoutesProducts } from "./../../constants";
import {
  UpdateProductRequestBody,
  UpdateProductResponseData
} from "./updateProduct.types";

export const requestUpdateProduct = async (
  body: UpdateProductRequestBody
): Promise<UpdateProductResponseData> => {
  return await instance.put(ApiRoutesProducts.Product, body);
};
